<!--
 * @Description: 
 * @Author: Rabbiter
 * @Date: 2023-03-04 15:31:03
-->
<template>
    <div
        style="
            text-align: center;
            height: 100%;
            padding: 20px 0 0 0;
            margin: 0px;
        "
    >
    <div class="userInfo">
        <el-image style="width: 100%;height: 80%;" :src="baseUrl+orderInfo.goodsImgUrl"></el-image>
    </div>
        
        <el-descriptions
            title=""
            :column="1"
            size="40"
            border
            style="padding: 20px 0 20px 0"
        >
            <el-descriptions-item>
                <template slot="label">
                    <i class="el-icon-apple"></i>
                    商品名称
                </template>

                <el-tag type="info">{{orderInfo.goodsName || " "}}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    <i class="el-icon-truck"></i>
                    进货渠道
                </template>
                <el-tag type="info">{{orderInfo.manufacturer || "待完善"}}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    <i class="el-icon-date"></i>
                    出货时间
                </template>
                <el-tag type="info">{{orderInfo.buyTime || "待同步"}}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item>
                <template slot="label">
                    <i class="el-icon-warning-outline"></i>
                    检验结果
                </template>
                <el-tag
                    type='success'
                    disable-transitions
                    >合格</el-tag
                >
            </el-descriptions-item>
        </el-descriptions>
    </div>
</template>

<script>
export default {
    name: "OrderInfo",
    data() {
        return {
			baseUrl:this.$httpUrl+"/images/",
            orderInfo: {},
        };
    },
	mounted() {
		debugger
	    let paramValue = this.$route.query.orderInfoId;
	    console.log(paramValue); // 输出: value
		this.init(paramValue)
	  },
    methods: {
        init(id) {
            this.$axios
                .post(this.$httpUrl + "/userorderinfo/qrDetail", {id})
                .then((res) => res.data)
                .then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        this.orderInfo=res.data
                    } else {
                        this.$message({
                            message: "操作失败！",
                            type: "error",
                        });
                    }
                });
        }
    },
    // created() {
    //     this.init();
    // },
};
</script>

<style scoped>
.el-descriptions {
    width: 100%;

    margin: 0 auto;
    text-align: center;
}

.userInfo {
    font-size: 32px;
}
</style>